/* eslint-disable @typescript-eslint/no-explicit-any */
import "moment/locale/es";
import { myHeaders } from "../../../../config/axios";
import { URL_API } from "../../../../config/default";
import { CustomToast } from "../../../../utils/custom-toast";

const Banners = ({
  data,
  setBanner,
  setModal,
}: {
  data: any;
  setBanner: any;
  setModal: any;
}) => {
  const onClick = (e: any, value: any) => {
    switch (e.target.name) {
      case "eliminar":
        {
          let formdata = new FormData();
          formdata.append("status", "inactivo");

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/users/${value.id}`, requestOptions)
            .then(async () => {
              //const property = await response.json();

              return CustomToast({
                status: 200,
                msg: "",
                title: "Usuario Inactivo",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "pausar":
        {
          let formdata = new FormData();
          formdata.append("status", "activo");

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/users/${value.id}`, requestOptions)
            .then(async () => {
              //const property = await response.json();

              return CustomToast({
                status: 200,
                msg: "",
                title: "Usuario Activo",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;
      case "activar":
        {
          let formdata = new FormData();
          formdata.append("status", "activo");

          const requestOptions = {
            method: "POST",
            body: formdata,
            headers: {
              Authorization: myHeaders, // Un ejemplo de header de autenticación
            },
          };

          fetch(`${URL_API}/users/${value.id}`, requestOptions)
            .then(async () => {
              //const property = await response.json();

              return CustomToast({
                status: 200,
                msg: "",
                title: "Usuario Activo",
              });
            })
            .then((result) => console.log(result))
            .catch((error) => console.error(error));
        }
        break;

      default:
        break;
    }
  };

  return (
    <div className="p-4 rounded-lg dark:bg-gray-800">
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-200 rounded-xl">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-3 px-6 text-left text-gray-700 font-semibold uppercase text-sm"></th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold uppercase text-sm">
                #ID
              </th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold uppercase text-sm">
                NOMBRE
              </th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold uppercase text-sm">
                LINK
              </th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold uppercase text-sm">
                UBICACIÓN
              </th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold uppercase text-sm">
                ESTADO
              </th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold uppercase text-sm">
                ACCIONES
              </th>
            </tr>
          </thead>
          <tbody>
            {data.data.map((banner: any) => {
              return (
                <tr className="border-b border-gray-200 hover:bg-gray-100">
                  <td className="py-3 px-6">
                    <div
                      className="overflow-hidden rounded-xl"
                      style={{
                        width: "150px",
                        height: "150px",
                        position: "relative",
                      }}
                    >
                      <div className="hover:scale-110 transition-transform duration-300">
                        <img src={banner.url} alt="" />
                      </div>
                    </div>
                  </td>
                  <td className="py-3 px-6">{banner.id}</td>
                  <td className="py-3 px-6">{banner.name}</td>
                  <td className="py-3 px-6">{banner.link}</td>
                  <td className="py-3 px-6">{banner.location}</td>
                  <td className="py-3 px-6">{banner.status}</td>
                  <td className="py-3 px-6">
                    <button
                      className="w-full xl:w-auto mb-1 bg-primary text-white px-4 py-2 rounded hover:opacity-[0.9] transition duration-500 me-2 font-semibold"
                      onClick={() => {
                        setBanner(banner);
                        setModal(true);
                      }}
                    >
                      EDITAR
                    </button>
                    <button
                      className="w-full xl:w-auto mb-1 bg-red text-white px-4 py-2 rounded hover:opacity-[0.9] transition duration-500 me-2 font-semibold"
                      name="inactivo"
                      onClick={(e) => onClick(e, banner)}
                    >
                      SUSPENDER
                    </button>
                    <button
                      className="w-full xl:w-auto mb-1 bg-blue-50 text-white px-4 py-2 rounded hover:opacity-[0.9] transition duration-500 font-semibold"
                      name="activar"
                      onClick={(e) => onClick(e, banner)}
                    >
                      ACTIVAR
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={7}></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default Banners;
